import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef, HostBinding,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";
import { MatDialog } from "@angular/material/dialog";
import { SuperLocationDialogComponent } from "./super-location-dialog/super-location-dialog.component";

@Component({
    selector: 'app-super-location',
    templateUrl: './super-location.component.html',
    styleUrls: ['../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SuperLocationComponent),
        }
    ]
})
export class SuperLocationComponent extends BaseControlValueAccessor implements OnInit {
    @Output() truckkun = new EventEmitter<any>();
    @ViewChild('title') portsListDiv: HTMLElement;
    @HostBinding('class') classes = 'super-location';

    constructor(
        private dialog: MatDialog, 
    ) {
        super();
       
    }

    truncateList:boolean ;

    ngOnInit(): void {
        this.truncateList=true;
    }
    

    openDialog() {
        const dialogRef = this.dialog.open(SuperLocationDialogComponent, {
            panelClass: 'vh80bod',
            width: '500px',
            disableClose: true,
            data: {
                portsData: [...this.data]
            }
        });

        dialogRef.afterClosed().subscribe((data) => {
            if (data) {
                this.data = data;
                // this.portsListDiv.scrollIntoView(false);
                this.truckkun.emit();
            }
        });
    }

    removePort(port) {
        this.data = this.data.filter(existing_port => !this.isPortEqual(port, existing_port));
        this.truckkun.emit();
    }

    isPortEqual(port1, port2) {
        return port1.id === port2.id;
    }

    toggleTruncate() {
        this.truncateList = !this.truncateList;
        // this.portsListDiv.scrollIntoView(false);
    }

}
